import { AddLinkCategory } from 'interface/link';
import * as Yup from 'yup';

export const addLinkCategorySchema: Yup.ObjectSchema<AddLinkCategory> = Yup.object({
  name: Yup.string().required('Please provide name').trim().typeError('Please provide name'),
});
